export { default } from './Col'



// WEBPACK FOOTER //
// ./src/components/Col/index.ts